module.exports = __webpack_public_path__ + "static/media/map-pin-gray.1117d18c.png";